import React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import * as Yup from 'yup';
import { useFormik, FormikProvider } from 'formik';
import { startLoginEmailPassword } from '../../actions/auth';
import { useDispatch } from 'react-redux';
import {
	justCentered,
	LOGO_PILU_LINK,
	LOGO_SARO_LINK,
	whichEnvURL,
	whichPath,
} from '../../helpers/utils';

// Credits component
const Credits = (props) => {
	return (
		<Typography
			variant='body2'
			color='text.secondary'
			align='center'
			{...props}
		>
			Hecho por{' '}
			<Link
				color='inherit'
				href='https://datagram-software.vercel.app/'
				target='_blank'
			>
				Datagram
			</Link>{' '}
			{new Date().getFullYear()}
			{'.'}
		</Typography>
	);
};

// Initial values for form
const initialValues = {
	email: '',
	password: '',
};

// Formik schema
const RegisterSchema = Yup.object().shape({
	email: Yup.string().nullable(true),
	password: Yup.string().nullable(true),
});

// MUI theme object
const theme = createTheme({
	status: {
		danger: '#e53e3e',
	},
	palette: {
		primary: {
			main: '#0971f1',
			darker: '#053e85',
		},
		'blue-puebla': {
			main: '#143f6c',
			contrastText: '#d60e399f',
		},
	},
});

export const imgWallpaperPiluLogo =
	'https://piluniformes.com.mx/img/home/pilu-uniformes-quienes-somos-uniformes-industriales-institucionales-tejidos-tecnicos-fabricantes-puebla-veracruz-cdmx-celaya-tabasco-monterrey.jpg';

/* Authentication component for register & login */
export const AuthComponent = () => {
	// State to know if user is signing or loggin
	const [isLogin] = useState(true);
	// Dispatch
	const dispatch = useDispatch();

	// Define formik object containting the
	// initial values and actions for the form
	const formik = useFormik({
		initialValues: initialValues,
		validationSchema: RegisterSchema,
		onSubmit: () => {
			const { email, password } = values;

			dispatch(startLoginEmailPassword(email, password));

			formik.resetForm(initialValues);
		},
	});

	// Desestructure formik values and methods
	const { getFieldProps, touched, errors, handleSubmit, values } = formik;

	// Text component for reuse
	const TextComp = (name, label, type = 'text') => (
		<TextField
			margin='normal'
			type={type}
			required
			fullWidth
			// style={{ width: '70%' }}
			{...getFieldProps(name)}
			label={label}
			error={Boolean(touched[name] && errors[name])}
			helperText={touched[name] && errors[name]}
		/>
	);

	return (
		<ThemeProvider theme={theme}>
			<FormikProvider value={formik}>
				<Grid container component='main' sx={{ height: '100vh' }}>
					<CssBaseline />
					{/* WALLPAPER BACKGROUND */}
					<Grid
						item
						xs={false}
						sm={4}
						md={7}
						sx={{
							backgroundImage: `url('${imgWallpaperPiluLogo}')`,
							backgroundRepeat: 'no-repeat',
							backgroundColor: (t) =>
								t.palette.mode === 'light'
									? t.palette.grey[50]
									: t.palette.grey[900],
							backgroundSize: 'cover',
							backgroundPosition: 'center',
						}}
					/>

					{/* LOGIN & REGISTER FORM */}
					<Grid
						item
						xs={12}
						sm={8}
						md={5}
						component={Paper}
						elevation={6}
						square
					>
						<Box
							sx={{
								my: 8,
								mx: 4,
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
							}}
						>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									...justCentered,
								}}
							>
								{/* Img Logo PILU */}
								<img
									style={{
										m: 1,
										width: '25%',
										height: '25%',
									}}
									src={LOGO_PILU_LINK}
									alt='avatar'
								/>

								{/* Img Logo SARO */}
								<img
									style={{
										margin: '0 0 0 20px',
										width: '30%',
										height: '30%',
									}}
									src={LOGO_SARO_LINK}
									alt='avatar'
								/>
							</div>

							{/* Title */}
							<Typography
								component='h1'
								variant='h5'
								className='mt-5'
							>
								Iniciar sesión
							</Typography>

							{/* Form */}
							<Box component='form' noValidate sx={{ mt: 1 }}>
								{/* Email field */}
								{TextComp('email', 'Correo electrónico')}

								{/* Password field */}
								{TextComp('password', 'Contraseña', 'password')}

								{/* Submit button */}
								<Button
									type='submit'
									fullWidth
									variant='contained'
									sx={{ mt: 3, mb: 2, color: 'white' }}
									color='blue-puebla'
									onClick={handleSubmit}
								>
									{isLogin ? 'Iniciar sesión' : 'Registrarme'}
								</Button>

								{/* Credits */}
								<center
									style={{
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'center',
										alignContent: 'center',
										marginTop: '4rem',
									}}
								>
									<div>
										<img
											src={
												`${whichPath()}/static/img/logo/logo-datagram.jpeg`
											}
											style={{
												// border: '1px solid red',
												margin: '1.5em auto 0 auto',
												height: '27%',
												width: '27%',
											}}
											alt='test'
											className='me-2'
											referrerPolicy='no-referrer'
										/>
									</div>
									<Credits sx={{ mt: 0.2 }} />
								</center>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</FormikProvider>
		</ThemeProvider>
	);
};
